import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import moment from 'moment';

import deTranslations from './language/de/index';
import enTranslations from './language/en/index';
import srTranslations from './language/sr/index';

const de = { translation: deTranslations };
const en = { translation: enTranslations };
const sr = { translation: srTranslations };

export const languages: any[] = [
  {
    key: 'sr',
    locale: 'sr',
    name: 'Serbian',
  },
];

export const findLocale = (lang: string): string =>
  languages.find((l) => lang === l.key)?.locale || 'sr_RS';

const resources = {
  de,
  en,
  sr,
};

i18n.use(LanguageDetector).use(initReactI18next).init({
  resources: resources,
  fallbackLng: 'de',
  debug: false,
  interpolation: {
    escapeValue: false,
    format: function (value, format, lng = 'de') {
      if (value instanceof Date) {
        return moment(value).locale(lng).format(format);
      }
      return value;
    },
  },
  detection: {
    order: ['cookie', 'localStorage', 'navigator'],
    caches: ['cookie'],
    cookieMinutes: 10080,
    lookupCookie: 'website_locale',
  },
});
i18n.on('languageChanged', function (lng) {
  moment.locale(lng);
});

export default i18n;